export default "__VITE_ASSET__Ym8IzzZml2rKdD_0zc0hXg__"